module.exports = __webpack_public_path__ + "img/index_banner.82d1e2ee.png";